import { render, staticRenderFns } from "./_casino.vue?vue&type=template&id=3a6ff454&lang=pug&"
import script from "./_casino.vue?vue&type=script&lang=js&"
export * from "./_casino.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports